import * as crypto from "crypto";

export const generateHash = () => {
    return crypto
        .createHash("sha1")
        .update(Date.now().toString())
        .digest("hex");
};
